import styled from 'styled-components';
import { Breakpoint, FONT_STACK, FontWeight } from '../../../styles/constants';
import { prop } from '../../../util/prop';

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    padding: 0px 8px;
  }

  ${Breakpoint.MEDIUM} {
    flex-direction: row-reverse;
  }
`;

export const HeroContent = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: center;

  ${Breakpoint.MEDIUM} {
    align-items: flex-start;
    flex: 2;
    padding: 100px 0 100px 100px;
    text-align: left;
  }

  ${Breakpoint.LARGE} {
    flex: 3;
  }
`;

export const Logo = styled.svg`
  height: 30px;
  margin-top: 30px;

  ${Breakpoint.LARGE} {
    height: 40px;
    max-width: 200px;
  }
`;

export const Title = styled.h1`
  ${FONT_STACK}
  font-size: 30px;
  font-weight: ${FontWeight.REGULAR};

  ${Breakpoint.LARGE} {
    font-size: 42px;
    line-height: 51px;
  }
`;

export const HeroImage = styled.div<{ imgxUrl: string }>`
  background-image: url(${prop('imgxUrl')});
  background-position: right top;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  height: 250px;
  padding: 0px;

  ${Breakpoint.SMALL} {
    height: 300px;
  }

  ${Breakpoint.MEDIUM} {
    flex: 2;
    height: unset;
    padding-inline-start: 30px;
  }
`;
